export const brandColors = {
  brandOne: '#006954',
  brandTwo: '#A3E953',
} as const;
